import React from 'react';
import styles from '../../Recurring.module.css';
import { CheckIcon } from '../../icons';

const left = [
  'Flexible scheduling',
  'Time-zone control',
  'Turn recurring on and off',
  'Pause without deleting your invoice',
  'Choose the preferred payment method',
];

const right = [
  'Send automatically to multiple recipients',
  'See all invoices on a recurring schedule',
  'Saved payment methods',
  'Automatic receipts every cycle',
  'Change sender or add recipients',
];

const Capabilities = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />All the details</span>
        <h2>Everything in recurring billing.</h2>
      </div>
      <div className={`${styles.capabilitiesGrid} ${styles.sr}`} data-sr>
        <ul className={styles.fList}>
          {left.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
        <ul className={styles.fList}>
          {right.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
      </div>
    </div>
  </section>
);

export default Capabilities;
